import { render, staticRenderFns } from "./FeatureSignature.vue?vue&type=template&id=478c1566&scoped=true"
import script from "./FeatureSignature.vue?vue&type=script&lang=js"
export * from "./FeatureSignature.vue?vue&type=script&lang=js"
import style0 from "./FeatureSignature.vue?vue&type=style&index=0&id=478c1566&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478c1566",
  null
  
)

export default component.exports